const inviteCreateUser = {
  toastr: 'Account created',
  toastr1: 'The account was created successfully'
};

export default inviteCreateUser;
